/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */

import { EngagekitChoreographerPlugin, type ProductIds } from '@atlassian/ipm-choreographer';

import { type Message } from '../../common/types/message';

export type MessagesResponse = { messages: Message[]; interval: number };

export const TARGETING_SCHEMA_VERSION = '2';

export async function getMessages(
	_cloudId: string,
	_stargateUrl: string,
	_product: string,
	_locale: string,
): Promise<MessagesResponse> {
	return { messages: [], interval: 0 };
}

export type StartMessageConfig = {
	cloudId: string;
	stargateUrl: string;
	messageId: string;
	variationId?: string;
	workspaceId?: string;
	orgId?: string;
};

export type StopMessageConfig = {
	cloudId: string;
	stargateUrl: string;
	messageId: string;
	workspaceId?: string;
	orgId?: string;
};

//  Adding these types because we are not able to import them properly from @atlassiansox/analytics-web-client
export enum envType {
	LOCAL = 'local',
	DEV = 'dev',
	STAGING = 'staging',
	PROD = 'prod',
}

export type Attributes = Record<string, unknown> & { sourceProductId?: ProductIds };

export type EventOverrides = {
	anonymousId?: string;
};

export type CoordinationOptions = {
	additionalData?: Attributes;
	enableChoreographer?: boolean;
	envType?: envType;
};
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let choreographerPlugin: EngagekitChoreographerPlugin;

export async function startMessage(
	startMessageConfig: StartMessageConfig,
	options?: CoordinationOptions,
): Promise<Awaited<ReturnType<typeof startMessageWithCoordination>>> {
	if (options?.enableChoreographer) {
		return startMessageWithChoreographer(startMessageConfig, options);
	}

	return startMessageWithCoordination(startMessageConfig);
}

export async function stopMessage(
	stopMessageConfig: StopMessageConfig,
	options?: CoordinationOptions,
): Promise<Awaited<ReturnType<typeof stopMessageWithCoordination>>> {
	if (options?.enableChoreographer) {
		return stopMessageWithChoreographer(stopMessageConfig, options);
	}

	return stopMessageWithCoordination(stopMessageConfig);
}

async function startMessageWithChoreographer(
	startMessageConfig: StartMessageConfig,
	options: CoordinationOptions,
): Promise<Awaited<ReturnType<typeof startMessageWithCoordination>>> {
	if (!choreographerPlugin) {
		choreographerPlugin = new EngagekitChoreographerPlugin(options.envType ?? envType.LOCAL);
	}

	return choreographerPlugin.startMessageWithPlugin(
		startMessageConfig.messageId,
		() => startMessageWithCoordination(startMessageConfig, true),
		options.additionalData,
	);
}

async function stopMessageWithChoreographer(
	stopMessageConfig: StopMessageConfig,
	options: CoordinationOptions,
): Promise<Awaited<ReturnType<typeof stopMessageWithCoordination>>> {
	if (!choreographerPlugin) {
		choreographerPlugin = new EngagekitChoreographerPlugin(options.envType ?? envType.LOCAL);
	}

	return choreographerPlugin.stopMessageWithPlugin(
		stopMessageConfig.messageId,
		() => stopMessageWithCoordination(stopMessageConfig, true),
		options.additionalData,
	);
}

async function startMessageWithCoordination(
	_startMessageConfig: StartMessageConfig,
	_choreographerEnabled = false,
): Promise<boolean> {
	return false;
}

async function stopMessageWithCoordination(
	_stopMessageConfig: StopMessageConfig,
	_choreographerEnabled = false,
): Promise<boolean> {
	return false;
}

export async function sendUserResponse(
	_cloudId: string,
	_stargateUrl: string,
	_messageId: string,
	_payload: unknown,
): Promise<void> {
	return Promise.resolve();
}

export type SeenMessageConfig = {
	cloudId: string;
	stargateUrl: string;
	messageId: string;
	workspaceId?: string;
	orgId?: string;
};

export async function markAsSeenAndFatigued(_seenMessageConfig: SeenMessageConfig): Promise<void> {
	return Promise.resolve();
}
